// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"HowItWorksPage_paragraph__32bsF"};